import Accordion from './accordion.js';

const selectors = {
  mobile_menu_open: '[data-open-mobile-menu]',
  mobile_menu_close: '[data-close-mobile-menu]',
  mobile_menu: '[data-mobile-menu]',
  bg_overlay: '[data-bg-overlay]',
  body: 'body',
  drawer_button: '[data-accordion-drawer-button]',
  child_drawer_button: '[data-accordion-child-drawer-button]',
  nav_drawer_content: '[data-accordion-drawer-content]',
};

const classes = {
  hide_menu: '-translate-x-full',
  hide_bg_overlay: 'inset-0',
  bg_black: 'bg-black/50',
  nav_accordion: '.nav-accordion',
  disable_scroll: 'overflow-hidden',
  disable_touch_scroll: 'touch-none',
  touch_scroll: 'touch-auto',
};

class NavigationMobile {
  constructor() {
    this.accordionInitilised = false;

    this.body = document.querySelector(selectors.body);
    this.mobileMenu = document.querySelector(selectors.mobile_menu) ?? false;
    this.mobileOpenBtn =
      document.querySelector(selectors.mobile_menu_open) ?? false;
    this.mobileCloseBtn =
      document.querySelector(selectors.mobile_menu_close) ?? false;
    this.bgOverlay = document.querySelector(selectors.bg_overlay) ?? false;
    this.drawerButton = document.querySelectorAll(selectors.drawer_button);
    this.childDrawerButton = document.querySelectorAll(
      selectors.child_drawer_button
    );
    this.drawerContent = document.querySelectorAll(
      selectors.nav_drawer_content
    );
    this.navAccordion = document.querySelector(classes.nav_accordion) ?? false;
    this.breakpoint = window.matchMedia('(max-width:1224px)');
    this.search = document.querySelectorAll(selectors.search);

    this.initEventListeners();
    this.handleAccordion();

    window.addEventListener('resize', () => {
      this.handleAccordionOnResize();
    });
  }

  initEventListeners() {
    if (!this.mobileOpenBtn || !this.mobileCloseBtn) return;

    this.mobileOpenBtn.addEventListener('click', () => {
      this.showMenu();
    });

    [this.mobileCloseBtn, this.bgOverlay].forEach(elem => {
      elem.addEventListener('click', () => {
        this.hideMenu();
      });
    });
  }

  showMenu() {
    this.mobileMenu.classList.remove(classes.hide_menu);
    this.showBgOverlay();
    this.disablePageScroll();
  }

  hideMenu() {
    this.mobileMenu.classList.add(classes.hide_menu);
    this.hideBgOverlay();
    this.enablePageScroll();
  }

  showBgOverlay() {
    this.bgOverlay.classList.add(classes.hide_bg_overlay);
    this.bgOverlay.classList.add(classes.bg_black);
  }

  hideBgOverlay() {
    this.bgOverlay.classList.remove(classes.bg_black);
    setTimeout(() => {
      this.bgOverlay.classList.remove(classes.hide_bg_overlay);
    }, 700);
  }

  disablePageScroll() {
    this.body.classList.add(
      classes.disable_scroll,
      classes.disable_touch_scroll
    );
    this.mobileMenu.classList.add(classes.touch_scroll);
  }

  enablePageScroll() {
    this.body.classList.remove(
      classes.disable_scroll,
      classes.disable_touch_scroll
    );
    this.mobileMenu.classList.remove(classes.touch_scroll);
  }

  handleAccordion() {
    if (this.breakpoint.matches) {
      this.initialiseAccordion();
    } else {
      this.removeAccordion();
    }
  }

  handleAccordionOnResize() {
    if (this.breakpoint.matches && !this.accordionInitilised) {
      this.reInitialiseAccordion();
    } else {
      this.removeAccordion();
    }
  }

  initialiseAccordion() {
    this.navAccordion.setAttribute('data-accordion', '');
    this.drawerButton.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });
    this.childDrawerButton.forEach(button => {
      button.setAttribute('aria-expanded', 'false');
    });

    if (!this.accordionInitilised) {
      this.accordionInitilised = true;
    }
  }

  reInitialiseAccordion() {
    this.initialiseAccordion();

    // eslint-disable-next-line no-new
    new Accordion(this.navAccordion);
  }

  removeAccordion() {
    this.navAccordion.removeAttribute('data-accordion');
    this.drawerButton.forEach(button => {
      button.removeAttribute('aria-expanded');
    });
    this.childDrawerButton.forEach(button => {
      button.removeAttribute('aria-expanded');
    });
    this.drawerContent.forEach(content => {
      content.removeAttribute('style');
    });

    if (!this.accordionInitilised) {
      this.accordionInitilised = false;
    }
  }
}

const createNavMobile = () => new NavigationMobile();
export default createNavMobile;
